<template>
    <v-container fluid>
        <v-row justify="center">
            <v-col v-if="[1].includes(account_type)" cols="12" sm="6" md="4" lg="3">
                <content-icon-card title="廠商個數" :content="content.vendor"></content-icon-card>
            </v-col>
            <v-col v-if="[1, 2].includes(account_type)" cols="12" sm="6" md="4" lg="3">
                <content-icon-card title="醫師個數" :content="content.doctor"></content-icon-card>
            </v-col>
            <v-col v-if="[1, 3].includes(account_type)" cols="12" sm="6" md="4" lg="3">
                <content-icon-card title="病人個數" :content="content.patient"></content-icon-card>
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="3">
                <content-icon-card title="問卷個數" :content="content.question"></content-icon-card>
            </v-col>
        </v-row>

        <!-- <v-row justify="center" class="mt-6">
            <v-select 
                v-if="[1, 2].includes(account_type)"
                v-model="type_" 
                :items="type_list" 
                single-line
                @change="selectType()"
                label="類別" 
                class="input_200" 
                outlined
            ></v-select>
            <v-text-field v-model="search_text" single-line="" class="input_600 ml-3" outlined></v-text-field>
            <v-btn large color="success" class="ml-3 mt-1" style="height: 46px; font-size: 18px;" @click="search_data(search_text)">搜尋</v-btn>
        </v-row> -->

        <v-row justify="center" >
            <v-col v-if="[1, 2].includes(account_type)" cols="12" sm="6">
                <v-card>
                    <v-card-title>
                        <v-col cols="4">
                            <v-select 
                                v-if="[1, 2].includes(account_type)"
                                v-model="type_" 
                                :items="type_list" 
                                single-line
                                dense
                                @change="selectType()"
                                label="類別" 
                                class="input_200" 
                                outlined
                                
                            ></v-select>
                        </v-col>
                        <v-col cols="8">
                            <v-text-field v-model="search_text" class="input_600 ml-3" placeholder="搜尋" append-icon="mdi-magnify" outlined></v-text-field>
                        </v-col>
                    </v-card-title>
                    <v-data-table :headers="headers" :items="table_data" :search="search_text" class="elevation-1">
                        <template v-slot:item.index="{ item }">
                            {{table_data.findIndex(items => { return items.name == item.name})+1}}
                        </template>
                        <template v-slot:item.right="{item}">
                            {{ item.right }}
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>

            <v-col v-if="[3].includes(account_type)" cols="12" sm="6">
                <v-card>
                    <v-card-title>
                        <v-text-field
                        v-model="search_text"
                        label="搜尋"
                        single-line
                        hide-details
                        ></v-text-field>
                    </v-card-title>
                    <v-data-table :headers="doctor_headers" :items="table_data" :search="search_text"  class="elevation-1">
                        <template v-slot:item.index="{ item }">
                            {{table_data.findIndex(items => { return items.patient_code == item.patient_code})+1}}
                        </template>
                        <template v-slot:item.right="{item}">
                            {{ item.right}}
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>

    </v-container>
</template>

<script>
import bus from '../nav/bus'

import ContentIconCard from '../materials/ContentIconCard'
var host_url = process.env.VUE_APP_HOST_URL
export default {
    components:{ContentIconCard},
    data(){
        return {
            type_: "",
            search_text: "",
            type_list: ['全部', '廠商', '醫師'],

            headers: [
                {text: '編號', align: 'center', value: 'index', width: 60, sortable: false},
                {text: '名稱', align: 'center', value: 'name', width: 60},
                {text: '權限', align: 'center', value: 'right', width: 60},
            ],

            doctor_headers: [
                {text: '編號', align: 'center', value: 'index', width: 60, sortable: false},
                {text: '病歷號碼', align: 'center', value: 'patient_code', width: 60},
                {text: '權限', align: 'center', value: 'right', width: 60},
            ],
            table_data: [],
            // account_type: 1,
            account_type: parseInt(localStorage.getItem('account_type')),
            content: {
                vendor: '0',
                doctor: '0',
                patient: '0',
                question: '0',
            },
        }
    },
    created(){
        this.init()
        this.get_each_type_count()
        console.log(this.account_type)
    },
    methods:{
        init(){
            let type_id = 0
            if(this.account_type === 1){
                this.type_list = ['全部', '廠商', '醫師']
                type_id = 0
            }
            else if (this.account_type === 2){
                this.type_list = ['醫師']
                type_id = 2
            }
            else if (this.account_type == 3){
                type_id = 3
            }

            
            axios.get(host_url+'get_list/?type_id='+String(type_id))
            .then(response => {
                var tmp = response.data
                if(tmp.status == true){
                    this.table_data = tmp.data
                    console.log(this.table_data)
                }
                else{
                    // bus.$emit('alert', {msg: tmp.msg, title: "錯誤提示",　check: "我知道了"})
                    this.table_data = []
                }
            })
            .catch((error) =>{
                // this.$ga.event('liff_manage', 'getliffevent', 'Error')
                console.log(error);
            });
        },
        get_data_list(){
            
        },
        get_each_type_count(){

            axios.get(host_url+'get_type_count/')
            .then(response => {
                var tmp = response.data
                if(tmp.status == true){
                    this.content = tmp.data
                }
                else{
                    // console.log('here')
                    // console.log(tmp)
                    bus.$emit('alert', {msg: tmp.msg, title: "錯誤提示",　check: "我知道了"})
                }
            })
            .catch((error) =>{
                // this.$ga.event('liff_manage', 'getliffevent', 'Error')
                console.log(error);
            });
        },
        selectType(){
            if(this.type_ == '全部'){
                this.search_text = ''
            }
            else{
                this.search_text = this.type_
            }
        },
        // selectType(){
            
        //     let type_id = 0;
        //     if(this.type_ === '廠商'){ type_id = 2}
        //     else if(this.type_ === '醫師'){ type_id = 3}

        //     axios.get(host_url+'get_list/?type_id='+String(type_id))
        //     .then(response => {
        //         var tmp = response.data
        //         if(tmp.status == true){
        //             this.table_data = tmp.data
        //         }
        //         else{
        //             bus.$emit('alert', {msg: tmp.msg, title: "錯誤提示",　check: "我知道了"})
        //             this.table_data = []
        //         }
        //     })
        //     .catch((error) =>{
        //         // this.$ga.event('liff_manage', 'getliffevent', 'Error')
        //         console.log(error);
        //     });
        // },
    }
}
</script>

<style lang="scss" scoped>

::v-deep .input_200{
    max-width: 200px;
}

::v-deep .input_600{
    max-width: 600px;
}


</style>